const VehicleStatus = {
    available: {
        value: 1,
        label: 'Available'
    },
    underOffer: {
        value: 2,
        label: 'Under Offer'
    },
    onHold: {
        value: 3,
        label: 'On Hold'
    },
    offerAccepted: {
        value: 4,
        label: 'Offer Accepted'
    },
    sold: {
        value: 5,
        label: 'Sold'
    },
};

export default VehicleStatus
